import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { ShipmentsData } from 'models/Shipments';
import {
    ShipmentLabelDetailsState,
    shipmentLabelDetailsDialogAction,
} from 'redux/slices/shipmentLabelDetailsDialogSlice';

const useShipmentLabelDetailsDialog = () => {
    const state: ShipmentLabelDetailsState = useAppSelector(
        (state) => state.shipmentLabelDetailsDialog
    );
    const dispatch = useAppDispatch();

    const showDialog = useCallback((open: boolean, props: ShipmentsData) => {
        if (open && props) {
            dispatch(
                shipmentLabelDetailsDialogAction.setShipmentLabelDetailsDialog(
                    props
                )
            );
            dispatch(shipmentLabelDetailsDialogAction.setOpen(open));
        } else {
            dispatch(
                shipmentLabelDetailsDialogAction.setShipmentLabelDetailsDialog(
                    null
                )
            );
            dispatch(shipmentLabelDetailsDialogAction.setOpen(open));
        }
    }, []);

    const closeDialog = () => {
        dispatch(shipmentLabelDetailsDialogAction.setOpen(false));
        dispatch(
            shipmentLabelDetailsDialogAction.setShipmentLabelDetailsDialog(null)
        );
    };

    return { ...state, showDialog, closeDialog };
};

export default useShipmentLabelDetailsDialog;
